import { render, staticRenderFns } from "./ProfileView.vue?vue&type=template&id=c36f4a92&scoped=true"
import script from "./ProfileView.vue?vue&type=script&lang=js"
export * from "./ProfileView.vue?vue&type=script&lang=js"
import style0 from "./ProfileView.vue?vue&type=style&index=0&id=c36f4a92&prod&lang=scss&scoped=true"
import style1 from "./ProfileView.vue?vue&type=style&index=1&id=c36f4a92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36f4a92",
  null
  
)

export default component.exports